import { ThumbUp } from '@mui/icons-material'
import { Avatar, Card, CardContent, CardHeader, CardMedia, IconButton, Stack, Typography } from '@mui/material'
import React from 'react'
import { demoChannelTitle, demoProfilePicture } from '../utils/constant'

const CommentCard = ({data}) => {
    
  return (
    <Card>
    <CardHeader
      avatar={
          <Avatar src={data?.topLevelComment?.snippet?.authorProfileImageUrl || demoProfilePicture} alt="hi
          "/>
      }
      title={
        <>
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 1, sm: 2, md: 4 }}
          >
            <Typography>{data?.topLevelComment?.snippet?.authorDisplayName || demoChannelTitle}</Typography> 
          </Stack>
        </>
      }
    />
    <CardContent sx={{paddingTop:"0px",paddingBottom:"0px"}} >
      <Typography variant="body2" color="text.secondary" >
      {data?.topLevelComment?.snippet?.textDisplay }
      </Typography>
    </CardContent>
    <IconButton>
      <ThumbUp /> {data?.topLevelComment?.snippet?.likeCount==0?``:data?.topLevelComment?.snippet?.likeCount}
    </IconButton>
  </Card>
  )
}

export default CommentCard